export type PairedCodeRule = {
  /** A 3-character category (`Z09` covers every Z09.x) or an exact code (`K62.7`). */
  anchors: readonly string[];
  /** Same forms as `anchors`. The partner is the code that moves; the anchor never does. */
  partners: readonly string[];
  /** What a partner is, in the words a coder should read in a tooltip: "history code", "external cause code". */
  partnerKind: string;
  /** Flag an anchor that has no partner present at all. */
  flagMissingPartner?: boolean;
  /** Left out, the rule applies to every specialty. */
  specialties?: readonly string[];
};

/**
 * One anchor goes with one partner, directly after it. To add a pair, add a row.
 * Z08/Z09 are NCCS DCS.XXI.2; the rest come from QA coders' practice (JIG-2038).
 */
export const PAIRED_CODE_RULES: readonly PairedCodeRule[] = [
  {
    anchors: ["Z08"],
    partners: ["Z85.0"],
    partnerKind: "history code",
    flagMissingPartner: true,
    specialties: ["endoscopy"],
  },
  {
    anchors: ["Z09"],
    partners: ["Z87.1", "Z86.0"],
    partnerKind: "history code",
    flagMissingPartner: true,
    specialties: ["endoscopy"],
  },
  { anchors: ["K62.7"], partners: ["Y84.2"], partnerKind: "external cause code" },
  { anchors: ["E89.0", "E89.2"], partners: ["Y83.6", "Y84.2"], partnerKind: "external cause code" },
  { anchors: ["G62.0"], partners: ["Y43.3"], partnerKind: "external cause code" },
  { anchors: ["K31.8"], partners: ["K76.6"], partnerKind: "portal hypertension code" },
];
